module.exports = __webpack_public_path__ + "img/zhipay.8da76a4e.jpg";